import { Button, ButtonGroup, Heading, Paragraph, TextButton } from '@zillow/constellation-10';
import { LeaseActionRestrictionType } from '@zg-rentals/ts-leasing-client';

import LeaseModal from './Containers/LeaseModal';
import { Property } from '../models';
import type { RouterHistory } from '../models/Types';

type Props = {
  property: Property;
  history: RouterHistory;
  restrictionType: LeaseActionRestrictionType;
  onClose(): void;
};

const RESTRICTION_CONTENT = {
  [LeaseActionRestrictionType.ARCHIVED_TEMPLATE_NO_REPLACEMENT]: {
    title: 'This lease cannot be duplicated',
    body: 'We no longer support this lease. Please create a new state level lease to continue.',
  },
  [LeaseActionRestrictionType.LEGACY_UPGRADE_TO_COSMOS]: {
    title: 'This lease cannot be duplicated',
    body: 'Lease duplication is no longer supported for this specific lease. Please create a new lease to continue.',
  },
};

function CopyLeaseRestrictionModal({ property, history, restrictionType, onClose }: Props): JSX.Element {
  const content = RESTRICTION_CONTENT[restrictionType];

  function onCreateNewLease() {
    history.push(Property.getCombinedOnboardingPath(property.id));
    onClose();
  }

  return (
    <LeaseModal
      id="copy-lease-restriction"
      isOpen
      onClose={onClose}
      header={<Heading level={1}>{content.title}</Heading>}
      body={<Paragraph>{content.body}</Paragraph>}
      footer={
        <ButtonGroup aria-label="copy lease restriction actions">
          <TextButton tone="brand" onClick={onClose}>
            Cancel
          </TextButton>
          <Button tone="brand" emphasis="filled" onClick={onCreateNewLease}>
            Create new lease
          </Button>
        </ButtonGroup>
      }
    />
  );
}

export default CopyLeaseRestrictionModal;
